'use client';

import { TrackedButton } from '@/components/button/tracked-button';
import { useInquiryChat } from '@/components/channel-talk';
import { TRACKED_EVENT_NAME, TRACKED_EVENT_POSITION } from '@/constants/gtag';

const LABEL = 'main-final-cta_consult';

export function FinalInquiryCta({ text }: { text: string }) {
  const inquiryChatProps = useInquiryChat();
  return (
    <TrackedButton
      {...inquiryChatProps}
      label={LABEL}
      eventName={TRACKED_EVENT_NAME.CTA_CLICK}
      position={TRACKED_EVENT_POSITION.MAIN_CTA}
      className="inline-flex h-11 items-center justify-center gap-1.5 rounded-full bg-[#ff142d] px-4 text-[14px] font-semibold text-white transition-colors hover:bg-white hover:text-3b-text-primary focus-visible:bg-white focus-visible:text-3b-text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white motion-reduce:transition-none xl:h-[71px] xl:px-[30px] xl:text-[20px] xl:font-bold"
    >
      {text}
      <span aria-hidden="true">→</span>
    </TrackedButton>
  );
}
